<script setup>
const props = defineProps({
  isPrivate: { type: Boolean, required: true }
});

const emit = defineEmits(['toggle']);

function onChange(event) {
  const input = event.target;
  if (input && 'checked' in input) {
    input.checked = props.isPrivate;
  }
  emit('toggle');
}
</script>

<template>
  <div class="btw-toggle-container hide-mobile">
    <span class="btw-toggle-label" :class="{ active: !isPrivate }">Zakelijk</span>
    <label class="btw-toggle-switch">
      <input
        id="vsb-btw-toggle"
        type="checkbox"
        :checked="isPrivate"
        aria-label="Prijzen inclusief of exclusief BTW"
        @change="onChange"
      />
      <span class="btw-slider"></span>
    </label>
    <span class="btw-toggle-label" :class="{ active: isPrivate }">Privé</span>
  </div>
</template>

<style scoped>
.btw-toggle-container {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  transition: background 0.3s ease;
}

.btw-toggle-container:hover {
  background: rgba(255, 255, 255, 0.2);
}

.btw-toggle-label {
  font-size: 16px;
  font-weight: 600;
  color: #4a4a4a;
  transition: all 0.3s ease;
  opacity: 0.6;
}

.btw-toggle-label.active {
  opacity: 1;
  font-weight: 700;
}

.btw-toggle-label:first-child.active {
  color: #10b981;
}

.btw-toggle-label:last-child.active {
  color: #ed1e24;
}

.btw-toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  margin: 0;
  cursor: pointer;
}

.btw-toggle-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  appearance: none;
}

.btw-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #10b981, #059669);
  transition: 0.4s;
  border-radius: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.btw-slider:before {
  position: absolute;
  content: '';
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background: white;
  transition: 0.4s;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

input:checked + .btw-slider {
  background: linear-gradient(135deg, #ed1e24, #c0392b);
}

input:checked + .btw-slider:before {
  transform: translateX(24px);
}

.btw-slider:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);
}

@media (max-width: 1024px) {
  .btw-toggle-label {
    font-size: 14px;
  }
}
</style>
